import { motion } from "framer-motion";
import HeroSlider     from "../Components/HeroSlider";
import SupportBanner  from "../Components/SupportBanner";

const heroImages = [
  "/images/image8.jpg",
  "/images/image21.JPG",
  "/images/image24.JPG",
  "/images/image14.jpg",
  "/images/image30.JPG",
  "/images/image32.JPG",
];

const ART_DIRECTORS = [
  { range: "1963 – 1965", names: "Kelemen István, Balogh István, Együd Árpád" },
  { range: "1965 – 1973", names: "Balogh István, Együd Árpád" },
  { range: "1973 – 1974", names: "Balogh István" },
  { range: "1974 – 1979", names: "Dr. Fekete Zoltán" },
  { range: "1979 – 1982", names: "Geiger Valéria, Leicht Károly" },
  { range: "1982 – 1984", names: "Szabó Zsolt" },
  { range: "1984 – 1986", names: "Geiger Valéria, Leicht Károly" },
  { range: "1986 – 1989", names: "Orsovszky István" },
  { range: "1989 – 1992", names: "Török Sándor" },
  { range: "1992 – 1995", names: "Szabó Zsolt" },
  { range: "1995 – 1998", names: "Kaposi Krisztina, Papp Károly" },
  { range: "1998 – 2001", names: "Angyal Mariann, Papp Károly" },
  { range: "2001 – 2011", names: "Szigeti Angéla, Papp Károly" },
  { range: "2011 – 2015", names: "Szigeti Angéla, Gőbölös Gábor" },
  { range: "2015 – 2016", names: "Kolumbán Norbert" },
  { range: "2016 – 2016", names: "Szigeti Angéla, Papp Károly" },
  { range: "2017 – 2017", names: "Fodor Janka, Specker Tamás" },
  { range: "2017 – 2019", names: "Kádár Ignác" },
  { range: "2019 –", names: "Fodor Janka, Csuti Péter" },
];

const LEADERS = [
  "Kelemen István", "Balogh István", "Geiger Valéria", "Koller Árpád",
  "Neisz Péter", "Müllerné Sipos Judit", "László József", "Papp Károly", "Tamás Lóránt",
];

const QUOTE = `„Közénk mindenki máshonnan jön, más gondokkal, örömökkel, felfogással. 
Ha azonban felvesszük jelmezeinket mindenki eggyé válik, megszűnnek a különbségek, eltűnnek a gondok. 
Tisztelet a hagyománynak, figyelem társainknak, önmagunk igényessége jelenik meg? Talán. 
Mi tudjuk, hogy megtaláltunk valamit, amit szeretünk, őrzünk.” (Papp Károly)`;

export default function AboutPage() {
  return (
    <main>
      <HeroSlider images={heroImages} />

      <section className="mx-auto grid max-w-6xl gap-14 px-6 py-20 md:grid-cols-2">
        <article className="space-y-5 text-lg leading-relaxed text-gray-700">
          <h1 className="text-4xl font-extrabold text-primary">Bemutatkozás</h1>
          <blockquote className="mx-auto max-w-4xl text-xl italic leading-relaxed">
            „A Balaton Táncegyüttes mindig is kiemelt helyen szerepelt mindkettőnk életében. 
            Az együttes utánpótlásából indulva, a felnőtt csoport ranglétráit végigjárva táncosai, 
            tánckarvezetői és jelenleg a művészeti vezetői is lehettünk, lehetünk ennek a nagyszerű együttesnek. 
            A legfiatalabb és az első olyan vezetői, akiket ez a közösség nevelt fel, nevelt ki. 
            Büszkeséggel tölt el minket ez a tény, ugyanakkor óriási felelősség is ez számunkra.
            Szakmai munkánkat az autentikus folklór mély ismerete, a táncosok magas tánctechnikai 
            fejlesztése, folklór és táncszínházi darabok készítése jellemzi, melynek alapja minden 
            esetben a tiszta forrás. A közösségünk ereje és összetartása meghatározza az együttest, 
            ez egy olyan kapocs, ami eggyé kovácsol mindnyájunkat. Célunk, hogy táncosainkkal bármerre is 
            járjunk, méltón képviseljük városunkat és a Balaton nevet.”
          </blockquote>
          <p>
            Fodor Janka, Csuti Péter jelenlegi művészeti vezetők
          </p>
        </article>

        <motion.img
          src="/images/image13.jpg"
          alt="Balaton Táncegyüttes előadás"
          className="h-80 w-full rounded-xl object-cover shadow-lg md:h-full"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        />
      </section>

      <section className="bg-primary py-12 text-center text-white px-6">
        <blockquote className="mx-auto max-w-4xl text-xl italic leading-relaxed">
          {QUOTE}
        </blockquote>
        <br></br>
        <p>Ez az idézet együttesünk egy 2000. évi műsorának plakátjáról való, de ugyanúgy igaz ma is. 
          És igaz volt akkor is, amikor 1963-ban három máshol, más módon, más korosztállyal működő kis 
          közösség kovácsolódott össze Balaton néven egy együttessé. Akkor merész álomnak tűnhetett, 
          de valahogy mindig a megfelelő embereket vezette erre a sors, hogy tovább lendítsék az ügyet. 
          Ennek az ügynek és ennek az álomnak az örökösei vagyunk ma mi.</p>
          <br></br>
          <p>
            1963 óta sok ember megfordult ebben a közösségben. Mindenki tett hozzá valamit, mindenki vitt innen valamit magával.
          </p>
          <br></br>
          <p>
            Sok minden változott azóta.
          </p>
          <br></br>
          <blockquote className="mx-auto max-w-4xl text-xl italic leading-relaxed">
            „Tisztelet a hagyománynak, figyelem társainknak.” …
          </blockquote>
          <p>
            … talán ez nem.
          </p>
      </section>

      <section id="timeline" className="mx-auto max-w-5xl px-6 py-20">
        <h2 className="mb-10 text-center text-3xl font-bold">Művészeti vezetők idővonala</h2>

        <ol className="relative border-s-2 border-primary/40 pl-10">
          {ART_DIRECTORS.map(({ range, names }) => (
            <li key={range} className="mb-8">
              <span className="absolute -start-[9px] bottom-8 h-4 w-4 rounded-full bg-primary" />
              <time className="mb-1 block font-semibold text-primary">{range}</time>
              <p className="text-gray-700">{names}</p>
            </li>
          ))}
        </ol>
      </section>

      <section className="bg-gray-50 py-16">
        <h2 className="mb-8 text-center text-2xl font-semibold">Együttesvezetők - Egyesületi elnökök</h2>

        <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-4 px-6">
          {LEADERS.map(name => (
            <span
              key={name}
              className="rounded-full bg-white px-4 py-2 text-sm shadow-md"
            >
              {name}
            </span>
          ))}
        </div>
      </section>

      <SupportBanner />
    </main>
  );
}
